import 'bootstrap/dist/css/bootstrap.min.css';
import { MyProjects } from './MyProjects';
import { Myİnfo } from './Myİnfo';
import { MyHistory } from './MyHistory'
import { Footer } from './Footer';

const Main = () => {

    return (
        <div className='container' >
            <Myİnfo/>
            <MyHistory/>
            <MyProjects/>
            <Footer/>
        </div>

    )

}

export default Main